import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Observable, of, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { LotteryClass } from "src/app/model/interfaces/lottery-class";
import { Order } from "src/app/model/interfaces/order";
import { PriceService } from "src/app/services/price.service";

@Component(
    {
        selector: 'app-pricing-update',
        templateUrl: './pricing-update.component.html',
        styleUrls: ['./pricing-update.component.scss']
    }
)
export class PricingUpdateComponent implements OnInit, OnDestroy
{
    @Output('onExpand')
    public onExpand = new EventEmitter();

    @Input()
    public order: Order;

    @Input()
    public expanded: boolean;

    public pricing: { visible: boolean, current: { months: string, price: number }, updated: { months: string, price: number } };

    private readonly priceService: PriceService;
    private readonly datePipe: DatePipe;
    private setPriceDataSubscription = new Subscription();

    public constructor(priceService: PriceService, datePipe: DatePipe)
    {
        this.priceService = priceService;
        this.datePipe = datePipe;
    }

    public expand(): void
    {
        // Delay pricing calculation until needed.
        if(!this.pricing)
        {
            this.setPriceDataSubscription = this.setPriceData().subscribe(_ => {
                this.expanded = true;
                this.onExpand.emit();
            });
        } else 
        {
            this.expanded = true;
            this.onExpand.emit();
        }
    }

    public ngOnInit(): void 
    {
        if(this.expanded)
        {
            this.expand();
        }
    }

    private setPriceData(): Observable<void>
    {
        return this.priceService.getPriceByOrder(this.order).pipe(map(
            (priceData) => {
                const groupedLotteryClasses = priceData.priceByLotteryClass.reduce(
                    (acc: { [key: number]: LotteryClass[] }, current) => { 
                        (acc[current.price] || (acc[current.price] = [])).push(current.lotteryClass);
                        return acc;
                    }, {}
                );
                
                const priceKeys = Object.keys(groupedLotteryClasses);
                const arrGroupedLotteryClasses = priceKeys.sort((a,b) => +a - +b).map(priceKey =>{ return { price: priceKey, classes: groupedLotteryClasses[priceKey] }; });

                // If we have 2 different prices: "old" & "new". Assuming lowest price being the "old"
                if(arrGroupedLotteryClasses.length == 2)
                {
                    this.pricing = {
                        visible: true,
                        current: {
                            months: arrGroupedLotteryClasses[0].classes.map(c => this.datePipe.transform(c.Draws[0].DrawDate, 'MMM')).join(', ').replace(/\./g, ''),
                            price: parseInt(arrGroupedLotteryClasses[0].price, 10)
                        },
                        updated: {
                            months: arrGroupedLotteryClasses[1].classes.map(c => this.datePipe.transform(c.Draws[0].DrawDate, 'MMM')).join(', ').replace(/\./g, ''),
                            price: parseInt(arrGroupedLotteryClasses[1].price, 10)
                        }
                    };
                }
            }
        ));
    }

    public ngOnDestroy(): void {
        this.setPriceDataSubscription.unsubscribe();
    }
}
